module.exports = __webpack_public_path__ + "img/allowed-browsers-only.257c07b2.png";